import Corporate from './Corporate';
export default Corporate;
